import { useShedConfig } from "../../contexts/ShedConfigContext";
import { SHED_STYLES } from "../../utils/constants";
import InfoTooltip from "../layout/InfoTooltip";

export default function ShedStyleSelector() {
  const { shedStyle, isAttached, setShedStyle, setAttached } = useShedConfig();

  const styles = [
    {
      id: SHED_STYLES.GABLE,
      name: "Gable",
      image: "/images/sheds/gable.jpeg",
    },
    {
      id: SHED_STYLES.BARN,
      name: "Barn",
      image: "/images/sheds/barn.jpeg",
    },
    {
      id: SHED_STYLES.LEAN_TO,
      name: "Lean to",
      image: "/images/sheds/lean-to.jpeg",
      tooltip:
        "If you choose the Lean-To style, the following two key options are activated: This option is mandatory for Lean-To style structures, since its design depends on whether it shares a wall or leans on the dwelling.",
    },
  ];

  return (
    <div className="my-4">
      <h3 className="text-center font-medium text-lg">Style</h3>
      <p className="text-center text-[14px] mb-2 mx-4">
        Select the design that best fits what you're going to install. You can
        choose from various visual options (gable, barn, Lean to).
      </p>

      <div className="flex flex-col gap-4 sm:flex-row items-center">
        {styles.map((style) => (
          <label
            key={style.id}
            className="flex flex-col items-center cursor-pointer mb-4"
          >
            <input
              type="radio"
              name="shedStyle"
              checked={shedStyle === style.id}
              onChange={() => setShedStyle(style.id)}
              className="mr-1 mt-4"
            />
            <img
              src={style.image}
              alt={style.name}
              className="w-48 lg:w-72 rounded"
            />
            <span className="text-xl block text-center">
              {style.name}
              {style.tooltip && <InfoTooltip>{style.tooltip}</InfoTooltip>}
            </span>
          </label>
        ))}
      </div>

      {shedStyle === SHED_STYLES.LEAN_TO && (
        <div className="text-center mt-6 mb-4">
          <span className="text-md font-semibold mt-2 mb-2">
            Attached to the house
          </span>
          <p className="text-[10px] mb-2 mx-12">
            Indicates if the structure will be attached to the house or be
            independent. This can affect permits or anchors required by your
            city or HOA.
          </p>
          <p>
            Yes
            <input
              type="radio"
              name="attached"
              checked={isAttached === true}
              onChange={() => setAttached(true)}
              className="mr-3 ml-1"
            />
            No
            <input
              type="radio"
              name="attached"
              checked={isAttached === false}
              onChange={() => setAttached(false)}
              className="mr-3 ml-1"
            />
          </p>
        </div>
      )}
    </div>
  );
}
